// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SetAcceptanceRequestModel from '../../model/set-acceptance-request-model';
import SetAcceptanceRequestDTO from '../dto/set-acceptance-request-dto';
import dtoSchema from '../schemas/set-acceptance-request-schema';

export default abstract class SetAcceptanceRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SetAcceptanceRequestDTO>) {
    super();
    if (data) {
      this.acceptGlaromatSihaTermsOfCondition = data.acceptGlaromatSihaTermsOfCondition ?? undefined;
    }
  }
  /**
  */
  acceptGlaromatSihaTermsOfCondition?: boolean;

  static toModel(dto: DeepPartial<SetAcceptanceRequestDTO>): SetAcceptanceRequestModel;
  static toModel(dto: DeepPartial<SetAcceptanceRequestDTO> | undefined | null): SetAcceptanceRequestModel | undefined;
  static toModel(dto: DeepPartial<SetAcceptanceRequestDTO> | undefined | null): SetAcceptanceRequestModel | undefined {
    return dto ? new SetAcceptanceRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SetAcceptanceRequestModel> | SetAcceptanceRequestModel): SetAcceptanceRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      acceptGlaromatSihaTermsOfCondition: unwrapped.acceptGlaromatSihaTermsOfCondition,
    } as SetAcceptanceRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SetAcceptanceRequestModel, can not map to SetAcceptanceRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
